import "./word-cloud.scss";
import { useState, useCallback, useEffect } from "react";
import api from "api";
import { Moment } from "moment";
import { ClipType } from "types";
import WordCloud from "react-d3-cloud";
import { useDispatch } from "react-redux";
import { actions } from "redux/reducers";

function WordCloudComponent({ projectId, dateFrom, dateTo, streamIds }: { projectId: number; dateFrom: Moment; dateTo: Moment; streamIds: number[] }) {
    const dispatch = useDispatch();
    const [cloudFilter, setCloudFilter] = useState<string>("@");
    const [wordCloudData, setWordCloudData] = useState<any[]>([]);
    const [maxOccurence, setMaxOccurence] = useState<number>(99);

    const getData = useCallback(async () => {
        const data = await api.wordCloud.getAllByClips(projectId, dateFrom, dateTo, streamIds, cloudFilter);
        if (!data.length) {
            setWordCloudData([
                {
                    text: "No Content",
                    value: 3,
                },
            ]);
            setMaxOccurence(0);
        } else {
            var words = [] as any[];
            console.log(data);
            data.map((x: any) => {
                if (cloudFilter === "*") {
                    if (x.Value.charAt(0) !== "#" && x.Value.charAt(0) !== "@") {
                        words.push({
                            text: `${x.Value}`,
                            value: x.Count,
                        });
                    }
                } else if (cloudFilter === "•") {
                    if (x.Value.charAt(0) !== "#" && x.Value.charAt(0) !== "@") {
                        words.push({
                            text: x.Value,
                            value: x.Count,
                        });
                    }
                } else if (x.Value.charAt(0) === cloudFilter) {
                    words.push({
                        text: cloudFilter === "@" ? `${x.Value}` : cloudFilter === "#" ? `${x.Value}` : x.Value,
                        value: x.Count,
                    });
                }
            });

            setWordCloudData(words);

            setMaxOccurence(
                Math.max.apply(
                    Math,
                    data.map(function (x: any) {
                        return x.Count;
                    })
                )
            );
        }
    }, [projectId, dateFrom, dateTo, streamIds, cloudFilter]);

    const onClick = useCallback(
        async (e, d) => {
            e.stopPropagation();
            dispatch(
                actions.clipTray.set({
                    open: true,
                    loading: true,
                    clips: [],
                })
            );
            const data = await api.clip.getAll(projectId, dateFrom, dateTo, streamIds.join(","));
            const clips = data.filter((x: ClipType) => x.Body.toLowerCase().replace(" ", "").includes(d.text.toLowerCase().substring(1)));
            console.log(clips);
            dispatch(
                actions.clipTray.set({
                    open: true,
                    loading: false,
                    clips: clips,
                })
            );
        },
        [dateFrom, dateTo, dispatch, projectId, streamIds]
    );

    const SelectWordCloudFilter = (filter: string) => {
        setCloudFilter(filter);
    };

    const getWordFontSize = useCallback(
        (word: any) => {
            var fontSize = 15;
            if (maxOccurence > 15 && wordCloudData.length > 10) {
                fontSize = Math.log2(word.value) * 5;
            } else if (maxOccurence < 10 && wordCloudData.length > 5) {
                fontSize = Math.log2(word.value) * 10;
            }
            return fontSize < 7 ? 7 : fontSize;
        },
        [maxOccurence, wordCloudData]
    );

    useEffect(() => {
        getData();
    }, [getData]);

    return (
        <div className="word-cloud">
            <div className="top">
                <p>Word Cloud</p>
            </div>
            <div className="body">
                <div className="word-cloud-filters">
                    <p className={`m-1 top-fil ${cloudFilter === "*" ? "selected" : ""}`} onClick={() => SelectWordCloudFilter("*")}>
                        <i className="far fa-asterisk font-size-9"></i> top words
                    </p>
                    <p className={`m-1 hash-fil ${cloudFilter === "#" ? "selected" : ""}`} onClick={() => SelectWordCloudFilter("#")}>
                        <i className="far fa-hashtag font-size-9"></i> hashtags
                    </p>
                    <p className={`m-1 at-fil ${cloudFilter === "@" ? "selected" : ""}`} onClick={() => SelectWordCloudFilter("@")}>
                        <i className="far fa-at font-size-9"></i> handles
                    </p>
                    <p className={`m-1 ne-fil ${cloudFilter === "•" ? "selected" : ""}`} onClick={() => SelectWordCloudFilter("•")}>
                        <i className="fad fa-dot-circle font-size-9"></i> named entities
                    </p>
                </div>
                <WordCloud
                    data={wordCloudData}
                    rotate={0}
                    padding={-5}
                    random={() => {
                        return 0.5;
                    }}
                    fontSize={useCallback((word) => getWordFontSize(word), [getWordFontSize])}
                    height={250}
                    fill={useCallback((word) => "#a31d42", [])}
                    onWordClick={onClick}
                    font="Nunito"
                />
            </div>
        </div>
    );
}

export default WordCloudComponent;
